import { Component, Input, NgZone, OnChanges, OnDestroy } from '@angular/core';
import { TWorkspaceUser } from '@project/view-models';
import { Subject, takeUntil } from 'rxjs';
import { TCombinedCustomField } from '../../../custom-fields/combine-custom-fields/combined-custom-field.model';
import { TAccountUser } from '../../../users/account.user.model';
import { UsersService } from '../../../users/users.service';
import { UserManagementUserSectionService } from './user-management-user-section.service';

@Component({
    selector: 'pp-user-management-user-section',
    templateUrl: './user-management-user-section.component.html',
    styleUrls: ['./user-management-user-section.component.scss'],
    standalone: false
})
export class UserManagementUserSectionComponent implements OnChanges, OnDestroy {
  @Input() ppUser: TAccountUser;
  @Input() ppAccountId: string;
  @Input() ppCustomFields: TCombinedCustomField[];

  expanded = false;
  isClosing = false;
  sites = [];
  user: TWorkspaceUser;
  animationDurationInSeconds = 0.5;

  private readonly destroy$ = new Subject<void>();

  constructor(
    private usersService: UsersService,
    private ngZone: NgZone,
    private userManagementUserSectionService: UserManagementUserSectionService,
  ) {
    this.userManagementUserSectionService.expandedUsersChange$
      .pipe(takeUntil(this.destroy$))
      .subscribe(() => {
        this.trySetInitialExpanded();
      });
  }

  ngOnChanges() {
    this.checkUser();
    this.trySetInitialExpanded();
  }

  ngOnDestroy(): void {
    this.destroy$.next();
  }

  private checkUser(): void {
    if (this.ppUser) {
      this.user = this.usersService.getUser(this.ppUser.userId);
    } else {
      this.user = null;
    }
  }

  private trySetInitialExpanded(): void {
    if (this.user) {
      this.expanded = this.userManagementUserSectionService.isExpandedUser(this.user.userId);
    }
  }

  onExpandedChange(expanded: boolean) {
    if (expanded) {
      this.expanded = true;
      this.isClosing = false;
      this.userManagementUserSectionService.toggleExpandedUser(this.user.userId, expanded);
    } else {
      this.isClosing = true;

      this.ngZone.runOutsideAngular(() => {
        setTimeout(() => {
          this.ngZone.run(() => {
            this.expanded = false;
            this.isClosing = false;

            this.userManagementUserSectionService.toggleExpandedUser(this.user.userId, expanded);
          });
        }, this.animationDurationInSeconds * 1000);
      });
    }
  }
}
